<template>
  <main class="call-center-page" role="main">    
        <vue-loading :active.sync="isLoading" 
        :can-cancel="false"         
        :is-full-page="false" />
    <div class="wizard-container" v-if="!isLoading">
      <vue-good-wizard 
        ref="wizard"
        :steps="dealSteps"
        :onNext="nextClicked" 
        :onBack="backClicked"
        >
          <div slot="product-selector">
            <product-selector :builder="builder" />
          </div>
          <div slot="subscriber-details">
            <subscriber-details :builder="builder" />
          </div>
          <div slot="complete"> 
            <order-details v-if="!isLoading" />
          </div>
      </vue-good-wizard>
      <button class="btn btn-lg btn-dark btn-block" @click="reset">RESET</button>
    </div>
  </main>
</template>

<script>

import { GoodWizard } from "vue-good-wizard";

import Selector from "./selector.vue";
import SubscriberDetails from "./subscriber-details.vue";
import OrderDetails from "./order-details.vue";

import EventBus from '@/components/shared/event-bus';
import store from "@/store";
import SubscriberModel from "@/models/subscriber.model";

import {   
  CART_UPDATE_SUBSCRIBER,  
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_RESET
} from "@/store/actions.type";

export default {
  name: "call-center",
  components: {
    "vue-good-wizard": GoodWizard,
    "product-selector": Selector,
    "subscriber-details": SubscriberDetails,
    "order-details": OrderDetails
  },
  data() {
    return {
      is_loading: true,
      builder: false,
      dealSteps: [
        {
          slot: "product-selector"
        },
        {
          slot: "subscriber-details"
        },
        {
          slot: "complete"
        }
      ]
    };
  },
  computed: {    
    isLoading() {
      return store.state.products.is_loading;
    },
  },
  mounted() {  
    var self = this;
    EventBus.$emit('hide_menu', true);
    EventBus.$emit('hide_footer', true);
    self.registerListeners();
  },
  methods: {
    nextClicked(currentPage) {
      var self = this;
      switch(currentPage) {
        case 0:
          return !self.isEmpty(store.state.cart.current_sim.deal);
        case 1:   
          EventBus.$emit("validate:subscriber");
          break; 
        case 2:            
          EventBus.$emit("validate:checkout");
          break; 
      }
    },
    backClicked(currentPage) {            
      switch(currentPage) {                  
        case 2:                              
          store.dispatch(CART_REMOVE_ITEM, store.state.cart.sims[0]);
          break;        
      }
      return true
    },
    isEmpty: function(data) {
      return (
        data == null ||
        typeof data == "undefined" ||
        Object.keys(data).length === 0
      );
    },
    registerListeners() {      
      var self = this;
      EventBus.$on("valid:subscriber", function(result) {     
          if(result.success) {            
            if(store.state.cart.sims.length == 0)
              store.dispatch(CART_ADD_ITEM, store.state.cart.current_sim.deal);
            self.$refs.wizard.goNext(result);
          }
      });
    },
    reset() {
      var self = this;            
      store.dispatch(CART_UPDATE_SUBSCRIBER, new SubscriberModel());
      store.dispatch(CART_RESET);
      self.$refs['wizard'].goTo(0);
    }
  }
};
</script>